module.exports = __webpack_public_path__ + "img/181.fe460f7d.jpg";